
/**
 * Route Constants
 * Centralized route path definitions for the application
 * Eliminates hardcoded route strings throughout the codebase
 */

export const ROUTES = {
  // Main routes
  HOME: '/',
  DASHBOARD: '/dashboard',
  IDEA: '/idea',
  BLUEPRINT: '/blueprint',
  ADMIN: '/admin',
  DIRECTORY: '/directory',
  
  // Feature routes
  LIVE_PITCH: '/live-pitch',
  RESEARCH: '/research',
  ANALYTICS: '/analytics',
} as const;

// Route parameter builders
export const buildRoute = {
  idea: (params?: { niche?: string }): string => {
    if (params?.niche) {
      return `${ROUTES.IDEA}?niche=${encodeURIComponent(params.niche)}`;
    }
    return ROUTES.IDEA;
  },
  
  blueprint: (params?: { id?: string }): string => {
    if (params?.id) {
      return `${ROUTES.BLUEPRINT}?id=${encodeURIComponent(params.id)}`;
    }
    return ROUTES.BLUEPRINT;
  },
  
  dashboard: (params?: { tab?: string }): string => {
    if (params?.tab) {
      return `${ROUTES.DASHBOARD}?tab=${encodeURIComponent(params.tab)}`;
    }
    return ROUTES.DASHBOARD;
  },
} as const;


